"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgTrendingUp = function (props) {
    var color = props.color;
    return (React.createElement("path", { fill: color, fillRule: "evenodd", d: "M6.30784 6.6823C6.50325 6.48704 6.82006 6.48704 7.01546 6.6823L9.84592 9.51073C10.4321 10.0965 11.3826 10.0965 11.9688 9.51073L17.9976 3.48626V6.00027C17.9976 6.55256 18.4456 7.00028 18.9983 7.00027C19.551 7.00027 19.999 6.55256 19.999 6.00027V1.0446C19.9997 1.02981 20 1.01494 20 1C20 0.447715 19.552 3.37175e-07 18.9993 0L13.9957 1.68587e-07C13.443 1.18011e-06 12.995 0.447715 12.995 1C12.995 1.55229 13.443 2 13.9957 2L16.6544 2L11.2612 7.3894C11.0658 7.58467 10.7489 7.58467 10.5535 7.3894L7.72308 4.56098C7.13687 3.97519 6.18644 3.97519 5.60023 4.56098L0.293104 9.86428C-0.0977014 10.2548 -0.0977015 10.888 0.293104 11.2785C0.68391 11.669 1.31753 11.669 1.70834 11.2785L6.30784 6.6823Z" }));
};
exports.default = factorySvgIcon_1.default(SvgTrendingUp);
//# sourceMappingURL=SvgTrendingUp.js.map